import { render, staticRenderFns } from "./damagePaused.vue?vue&type=template&id=28ede671&scoped=true"
import script from "./damagePaused.vue?vue&type=script&lang=js"
export * from "./damagePaused.vue?vue&type=script&lang=js"
import style0 from "./damagePaused.vue?vue&type=style&index=0&id=28ede671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ede671",
  null
  
)

export default component.exports